import React from 'react';
import { Lock, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

interface UpgradePromptProps {
  feature: string;
  onUpgradeClick?: () => void;
  compact?: boolean;
  requiredPlan?: 'pro' | 'clinic';
}

const PLAN_LABELS: Record<string, string> = {
  free: 'Gratuito',
  pro: 'Pro',
  clinic: 'Clínica Completa',
  super_admin: 'Admin',
};

const UpgradePrompt: React.FC<UpgradePromptProps> = ({ feature, onUpgradeClick, compact, requiredPlan = 'pro' }) => {
  const { t } = useTranslation();
  const { subscription } = useAuth();

  const requiredLabel = requiredPlan === 'clinic' ? 'Clínica Completa' : 'Pro';
  const currentLabel = PLAN_LABELS[subscription.plan] ?? 'Gratuito';

  if (compact) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        fontSize: 12, color: 'var(--ink-muted)',
        background: 'color-mix(in srgb, var(--accent) 10%, var(--surface))',
        border: '1px solid color-mix(in srgb, var(--accent) 25%, transparent)',
        borderRadius: 99, padding: '2px 8px',
      }}>
        <Lock size={10} />
        {requiredLabel}
      </span>
    );
  }

  return (
    <div className="upgrade-block">
      <div className="upgrade-icon">
        <Sparkles size={24} />
      </div>
      <h2>{feature} é um recurso {requiredLabel}</h2>
      <p>
        Você está no plano {currentLabel}. Faça upgrade para o {requiredLabel} e tenha acesso
        a {feature}, além de todos os recursos premium que sua clínica precisa.
      </p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
        {onUpgradeClick && (
          <>
            <button className="btn-s" onClick={() => onUpgradeClick()}>
              {t('upgrade.viewDetails')}
            </button>
            <button className="btn-s primary" onClick={() => onUpgradeClick()}>
              Assinar {requiredLabel}
            </button>
          </>
        )}
      </div>
      <p style={{ fontSize: 11.5, color: 'var(--ink-faint)', marginTop: 18 }}>
        {t('upgrade.trialNote')}
      </p>
    </div>
  );
};

export default UpgradePrompt;
